import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom' 
import Header from "../Component/Header";
import LazyLoad from "react-lazyload";
const MiRoom = () => {
    useEffect(() => {
        document.title = ' MI Room -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Facilities </li>
                 <li>MI Room</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> MI Room </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-4">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/miroom.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/miroom.png" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
                   <div className="col-lg-4">
                   <LazyLoad>
                   <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/miroom1.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/miroom1.png" className="schoollib img-fluid" alt="TAFS" /></a> 
                 </LazyLoad>  
                  </div>
                  <div className="col-lg-12">
                         <p>The School has engaged a part-time Doctor and one nurse, who are available round the clock. They provide minor medical relief and first-aid of the following kind: </p>
                         <p> Minor stitches and dressing in case of injury. </p>
                        <p> I V drip for use in an emergency situation. </p>
                        <p> Heat treatment to children suffering from Joint and Muscular pain. </p>
                        <p> Bronchodilator drugs in emergency cases of Asthma </p>
                   </div>
                </div>
            </div>
            </div>
        
     </>
  )
}

export default MiRoom